/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSustainableLivingWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSustainableLivingWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Live Sustainably!",
    "Sustainable Living Workshop Awaits!",
    "Embrace Eco-Friendly Practices!",
  ],
  title: "Sustainable Living Workshop",
  description: "Organize a fun sustainable living workshop.",
  longDescription:
    "Gather your friends for an engaging sustainable living workshop! Choose a date, decide on topics, and plan activities!",
  emoji: "🌱",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Sustainable Living Workshop",
          emoji: "🌱",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the sustainable living workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on topics to cover?",
            description: "What topics should we explore during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What topics should we consider?",
                emoji: "📚",
                completeAction: {
                  question: "Decide on activities for the workshop?",
                  description: "What activities should we include?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we plan?",
                      emoji: "♻",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Embrace Sustainability!",
    outroDescription:
      "Your sustainable living workshop plans are set! Enjoy the journey!",
  },
};
